import {Entity} from "../state/helpers/Entity"

declare global {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
   interface Array<T> {
        removeEntity<T extends Entity>(entity: T): void
        updateEntity<T extends Entity>(entity: T): void
    }
}

Object.defineProperty(Array.prototype, "removeEntity", {
    value: function <T extends Entity>(elem: T) {
        const index = this.indexOf(elem)
        if (index > -1) {
            this.splice(index, 1)
        }
    }
})

Object.defineProperty(Array.prototype, "updateEntity", {
    value: function <T extends Entity>(entity: T) {
        const index = this.findIndex((e: T) => e.getId() == entity.getId())
        if (index != -1) {
            this[index] = entity
        }
    }
})




// WEBPACK FOOTER //
// ./src/common/Prototype.ts